import { Env } from '../contexts/AppContext';

interface getImgxSrcParams {
  path: string;
  isDevDependence: boolean;
  envContext: Env;
}

export const getImgxSrc = ({ path, isDevDependence, envContext }: getImgxSrcParams) => {
  const env = isDevDependence ? 'global' : envContext.IMGIX_ENV;
  const root = envContext.IMGIX_URL;
  return `${root}/${env}/${path}`;
};

export const getArticleImgSrc = (id: number, picture: string, env: Env) => {
  if (!picture) {
    return getImgxSrc({
      path: 'articles/article_default_rebrand.jpg',
      isDevDependence: false,
      envContext: env,
    });
  }

  return getImgxSrc({
    path: `articles/${id}/${picture}`,
    isDevDependence: false,
    envContext: env,
  });
};
